import React from 'react';
import { reportType } from '../../../../infrastructure/constants/reportType';
import './ReportComponentStatus.scss';

interface ReportComponentStatusProps {
    reportType: string;
    lastUpdatedTime: string | undefined;
    isReadOnly: boolean;
}

class ReportComponentStatus extends React.Component<ReportComponentStatusProps> {

    render(): JSX.Element {

        if (this.props.reportType !== reportType.accuracy) {

            return <></>;
        }

        return (
            <>
                {
                    this.props.lastUpdatedTime && this.props.isReadOnly &&
                    <span className="published">LAST RELEASE: {this.props.lastUpdatedTime}Z</span>
                }
                {
                    this.props.lastUpdatedTime && !this.props.isReadOnly &&
                    <span className="unpublished">UNPUBLISHED CHANGES</span>
                }
            </>
        );
    }
}

export default ReportComponentStatus;
